import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { useLanguage } from "../../i18n/LanguageContext";

const COLORS = ["#C9963B", "#6366F1", "#22C55E", "#F59E0B", "#EF4444"];

const CostByModelChart = ({ data }) => {
  const { t } = useLanguage();
  const chartData = data
    ? Object.entries(data).map(([model, info]) => ({
        name: model.split("/").pop(),
        value: info.cost_usd,
      }))
    : [];

  return (
    <Card className="border border-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{t("platform.spendByModel")}</CardTitle>
      </CardHeader>
      <CardContent>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={80}
                dataKey="value"
                paddingAngle={2}
              >
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
                formatter={(v) => [`$${v.toFixed(2)}`, t("platform.spend")]}
              />
              <Legend
                formatter={(val) => <span className="text-xs text-muted-foreground">{val}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[220px] flex items-center justify-center text-sm text-muted-foreground">
            {t("platform.noData")}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CostByModelChart;
